import React, { useState, useEffect } from "react";
import "./table.css";
import Loading from "./Loading.js";
import url from "../constants/URL";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";

const Complaints = (props) => {
  const [loading, setLoading] = useState(true);
  const [complaints, setComplaints] = useState([]);
  const [allLoaded, setAllLoaded] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const token = await JSON.parse(localStorage.getItem("persist:auth")).token;
    fetch(`${url}/shop/complaints/${props.auth.seller._id}/?skip=${complaints.length}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then(async (resp) => {
      const data = await resp.json();
      if (data.length < 10) {
        setAllLoaded(true);
      }
      if (complaints.length === 0) {
        setComplaints(data);
        setLoading(false);
      } else {
        setComplaints([...data, ...complaints]);
        setLoadingMore(false);
      }
    });
  };

  const loadMoreItems = () => {
    setLoadingMore(true);
    fetchData();
  };

  if (loading) {
    return <Loading />;
  }
  if (!loading && complaints.length === 0) {
    return <div>No Complaint Yet</div>;
  }
  return (
    <div className="container">
      <p style={{ marginLeft: 20, fontSize: 24 }}>Customer's Complaints</p>
      <hr />
      <div className="table_container">
        <table>
          <tr>
            <th className="table_head">Number</th>
            <th className="table_head">Order Id</th>
            <th className="table_head">Buyer Name</th>
            <th className="table_head">Date</th>
            <th className="table_head">Complaint</th>
          </tr>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              if (!loadingMore) {
                loadMoreItems();
              }
            }}
            hasMore={!allLoaded}
            threshold={8}
            style={{ display: "table-row-group" }}
          >
            {complaints.map((val, key) => {
              return (
                <tr key={key}>
                  <td>{key + 1}</td>
                  <td>
                    <Link
                      to={`/receipt/${val.order}`}
                      style={{
                        color: "cornflowerblue",
                        fontStyle: "italic",
                        textDecoration: "underline",
                        textDecorationColor: "cornflowerblue",
                      }}
                    >
                      {val.order}
                    </Link>
                  </td>
                  <td>{val.buyer.name}</td>
                  <td>{new Date(val.time).toLocaleDateString()}</td>
                  <td>{val.description}</td>
                </tr>
              );
            })}
          </InfiniteScroll>
        </table>
      </div>
      {loadingMore && (
        <div>
          <h3
            style={{ color: "green", textAlign: "center", paddingBottom: 30 }}
          >
            Loading More...
          </h3>
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Complaints);
